import React from 'react';
import { ButtonProps, Button } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';

interface Props extends ButtonProps {
  isBack: boolean;
}
export const ButtonCancel: React.FC<React.PropsWithChildren<Props>> = ({ isBack, ...rest }) => {
  const { t } = useTranslate();

  return (
    <Button
      children={t(isBack ? 'back' : 'cancel')}
      variant={'text'}
      color={'secondary'}
      {...rest}
    />
  );
};
